var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vl-parent"},[_c('loading',{attrs:{"active":true,"color":_vm.color,"is-full-page":true,"loader":"bars","width":100,"height":250}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }